var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreamshopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1411 16.7927V11.8194H15.2417V10.1898H21.0516V11.8194H19.1522V16.7927H17.1411Z",
    fill: "url(#paint0_linear_1542_2475)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9868 16.7927V10.1898H25.2176C25.9935 10.1898 26.5925 10.3771 27.0146 10.7517C27.4366 11.1263 27.6477 11.6446 27.6477 12.3064C27.6477 12.7435 27.5515 13.1213 27.3591 13.4397C27.1728 13.7519 26.8966 13.9954 26.5304 14.1702C26.1642 14.3388 25.7204 14.4231 25.199 14.4231L25.2641 14.1515H25.8135C26.0866 14.1515 26.3318 14.2327 26.549 14.395C26.7663 14.5511 26.9463 14.7572 27.089 15.0132L28.1039 16.7927H25.8973L24.7707 14.7135C24.721 14.6198 24.6403 14.5542 24.5286 14.5168C24.4169 14.4731 24.302 14.4512 24.1841 14.4512H23.9979V16.7927H21.9868ZM23.9979 13.037H24.8545C25.14 13.037 25.3572 12.9839 25.5062 12.8778C25.6552 12.7654 25.7297 12.5968 25.7297 12.372C25.7297 12.1535 25.6552 11.9911 25.5062 11.885C25.3572 11.7788 25.14 11.7258 24.8545 11.7258H23.9979V13.037Z",
    fill: "url(#paint1_linear_1542_2475)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9673 16.7927V10.1898H33.8368V11.7258H30.8853V12.6717H33.6133V14.2077H30.8853V15.2567H33.8368V16.7927H28.9673Z",
    fill: "url(#paint2_linear_1542_2475)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9637 16.7927L37.0828 10.1898H38.7122L41.8499 16.7927H39.8388L39.0567 15.0038L39.8109 15.5658H36.0028L36.7476 15.0038L35.9655 16.7927H33.9637ZM37.8929 12.2502L36.9339 14.5636L36.6545 14.0391H39.1591L38.9077 14.5636L37.9394 12.2502H37.8929Z",
    fill: "url(#paint3_linear_1542_2475)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3834 16.7927V10.1898H44.1338L46.1263 14.676H45.8098L47.8023 10.1898H49.5527V16.7927H47.7371V13.2243H48.184L46.5081 16.7927H45.4001L43.7242 13.2243H44.199V16.7927H42.3834Z",
    fill: "url(#paint4_linear_1542_2475)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6595 24.4024V18.6249H17.1667V20.8539H19.4804V18.6249H20.9876V24.4024H19.4804V22.0914H17.1667V24.4024H15.6595Z",
    fill: "url(#paint5_linear_1542_2475)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2823 21.5096C21.2823 20.9086 21.3991 20.3868 21.6327 19.9443C21.8662 19.4963 22.2002 19.1494 22.6347 18.9035C23.0692 18.6577 23.5825 18.5347 24.1745 18.5347C24.7719 18.5347 25.2879 18.6577 25.7224 18.9035C26.1569 19.1494 26.4909 19.4963 26.7245 19.9443C26.9635 20.3868 27.0829 20.9086 27.0829 21.5096C27.0829 22.1051 26.9635 22.6268 26.7245 23.0748C26.4909 23.5228 26.1569 23.8725 25.7224 24.1238C25.2879 24.3697 24.7719 24.4926 24.1745 24.4926C23.5825 24.4926 23.0692 24.3697 22.6347 24.1238C22.2057 23.8725 21.8716 23.5228 21.6327 23.0748C21.3991 22.6268 21.2823 22.1051 21.2823 21.5096ZM22.8547 21.5096C22.8547 22.0504 22.9633 22.4739 23.1806 22.7798C23.3978 23.0803 23.7291 23.2305 24.1745 23.2305C24.6199 23.2305 24.9539 23.0803 25.1766 22.7798C25.3993 22.4739 25.5106 22.0504 25.5106 21.5096C25.5106 20.9687 25.3993 20.548 25.1766 20.2475C24.9539 19.947 24.6199 19.7968 24.1745 19.7968C23.7291 19.7968 23.3978 19.947 23.1806 20.2475C22.9633 20.5425 22.8547 20.9632 22.8547 21.5096Z",
    fill: "url(#paint6_linear_1542_2475)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3739 24.4024V18.6249H30.1927C30.8553 18.6249 31.355 18.7888 31.6917 19.1166C32.0285 19.4389 32.1968 19.8787 32.1968 20.436C32.1968 20.9878 32.0285 21.4276 31.6917 21.7554C31.355 22.0832 30.8553 22.2471 30.1927 22.2471H28.8811V24.4024H27.3739ZM28.8811 21.0834H29.9972C30.2525 21.0834 30.4425 21.0288 30.5675 20.9195C30.6924 20.8048 30.7548 20.6436 30.7548 20.436C30.7548 20.2284 30.6924 20.0672 30.5675 19.9525C30.4425 19.8378 30.2525 19.7804 29.9972 19.7804H28.8811V21.0834Z",
    fill: "url(#paint7_linear_1542_2475)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.332 24.4024V18.6249H35.1509C35.8135 18.6249 36.3132 18.7888 36.6499 19.1166C36.9866 19.4389 37.155 19.8787 37.155 20.436C37.155 20.9878 36.9866 21.4276 36.6499 21.7554C36.3132 22.0832 35.8135 22.2471 35.1509 22.2471H33.8392V24.4024H32.332ZM33.8392 21.0834H34.9553C35.2106 21.0834 35.4007 21.0288 35.5256 20.9195C35.6505 20.8048 35.713 20.6436 35.713 20.436C35.713 20.2284 35.6505 20.0672 35.5256 19.9525C35.4007 19.8378 35.2106 19.7804 34.9553 19.7804H33.8392V21.0834Z",
    fill: "url(#paint8_linear_1542_2475)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2902 24.4024V18.6249H38.7974V24.4024H37.2902Z",
    fill: "url(#paint9_linear_1542_2475)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.249 24.4024V18.6249H40.3569L43.2654 22.2553H43.0291V18.6249H44.4222V24.4024H43.3143L40.4221 20.772H40.6584V24.4024H39.249Z",
    fill: "url(#paint10_linear_1542_2475)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8003 24.4926C47.1323 24.4926 46.5674 24.3697 46.1058 24.1238C45.6496 23.878 45.302 23.5338 45.063 23.0912C44.8294 22.6487 44.7127 22.1324 44.7127 21.5423C44.7127 20.9304 44.8403 20.4005 45.0956 19.9525C45.3563 19.499 45.7283 19.1494 46.2117 18.9035C46.6951 18.6577 47.2762 18.5347 47.9551 18.5347C48.3733 18.5347 48.7427 18.5839 49.0631 18.6822C49.389 18.7806 49.6687 18.9226 49.9022 19.1084L49.4379 20.2639C49.2695 20.1492 49.1093 20.0618 48.9572 20.0017C48.8106 19.9361 48.6585 19.8897 48.501 19.8623C48.3489 19.835 48.1724 19.8214 47.9714 19.8214C47.4066 19.8214 46.9829 19.9689 46.7005 20.2639C46.4235 20.5535 46.285 20.9796 46.285 21.5423C46.285 22.0996 46.4126 22.5203 46.6679 22.8044C46.9232 23.0885 47.3278 23.2305 47.8818 23.2305C48.0502 23.2305 48.2321 23.2141 48.4276 23.1814C48.6286 23.1486 48.8323 23.0994 49.0387 23.0338L48.7698 23.5747V22.1979H47.5804V21.149H50V24.0419C49.6904 24.1894 49.3428 24.3014 48.9572 24.3779C48.577 24.4543 48.1914 24.4926 47.8003 24.4926Z",
    fill: "url(#paint11_linear_1542_2475)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.28947C0 6.1966 1.56321 4.5 3.49153 4.5H10.4746C12.4029 4.5 13.9661 6.1966 13.9661 8.28947V24.7105C13.9661 26.8034 12.4029 28.5 10.4746 28.5H3.49153C1.56321 28.5 0 26.8034 0 24.7105V8.28947ZM3.49153 5.76316C2.20599 5.76316 1.16384 6.89423 1.16384 8.28947V24.7105C1.16384 26.1058 2.20599 27.2368 3.49153 27.2368H10.4746C11.7601 27.2368 12.8023 26.1058 12.8023 24.7105V8.28947C12.8023 6.89423 11.7601 5.76316 10.4746 5.76316H3.49153Z",
    fill: "url(#paint12_linear_1542_2475)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89368 13.5732C8.85952 13.1436 8.69936 12.8085 8.41322 12.5679C8.13136 12.3273 7.70215 12.207 7.1256 12.207C6.75832 12.207 6.45723 12.2521 6.22234 12.3424C5.99172 12.4283 5.82089 12.5464 5.70985 12.6968C5.59881 12.8471 5.54116 13.019 5.53689 13.2123C5.52834 13.3713 5.5561 13.5152 5.62017 13.6441C5.6885 13.7686 5.79526 13.8825 5.94047 13.9856C6.08567 14.0844 6.27145 14.1746 6.4978 14.2562C6.72415 14.3379 6.99321 14.4109 7.30497 14.4753L8.38119 14.7073C9.10722 14.862 9.72861 15.066 10.2454 15.3195C10.7621 15.573 11.1849 15.8715 11.5138 16.2152C11.8426 16.5546 12.0839 16.9369 12.2377 17.3622C12.3957 17.7876 12.4768 18.2515 12.4811 18.7542C12.4768 19.6219 12.2612 20.3566 11.8341 20.958C11.407 21.5594 10.7963 22.017 10.0019 22.3306C9.21185 22.6442 8.26161 22.801 7.15122 22.801C6.01094 22.801 5.01586 22.6313 4.16598 22.2919C3.32037 21.9525 2.66268 21.4306 2.1929 20.726C1.72739 20.0172 1.4925 19.1107 1.48823 18.0066H4.87065C4.892 18.4105 4.99237 18.7499 5.17174 19.0248C5.35111 19.2997 5.60308 19.5081 5.92766 19.6499C6.2565 19.7916 6.64728 19.8625 7.09997 19.8625C7.48007 19.8625 7.79824 19.8153 8.05448 19.7208C8.31073 19.6262 8.50505 19.4952 8.63744 19.3277C8.76983 19.1601 8.83816 18.969 8.84243 18.7542C8.83816 18.5522 8.77197 18.3761 8.64384 18.2257C8.51999 18.0711 8.315 17.9336 8.02886 17.8133C7.74272 17.6887 7.35622 17.5728 6.86935 17.4654L5.56251 17.1818C4.40087 16.9284 3.4848 16.5052 2.81429 15.9123C2.14806 15.3152 1.81708 14.5011 1.82135 13.4701C1.81708 12.6323 2.03915 11.8999 2.48758 11.2727C2.94028 10.6411 3.56594 10.1493 4.36457 9.79698C5.16747 9.44471 6.08781 9.26857 7.1256 9.26857C8.18474 9.26857 9.10081 9.44685 9.87382 9.80342C10.6468 10.16 11.2426 10.6626 11.6611 11.3113C12.0839 11.9557 12.2975 12.7097 12.3017 13.5732H8.89368Z",
    fill: "url(#paint13_linear_1542_2475)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14691 25.5732C8.14691 26.2197 7.62584 26.7439 6.98306 26.7439C6.34029 26.7439 5.81922 26.2197 5.81922 25.5732C5.81922 24.9266 6.34029 24.4024 6.98306 24.4024C7.62584 24.4024 8.14691 24.9266 8.14691 25.5732Z",
    fill: "url(#paint14_linear_1542_2475)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2373 5.67073C5.2373 5.34744 5.49783 5.08537 5.81922 5.08537H8.14691C8.46829 5.08537 8.72883 5.34744 8.72883 5.67073V6.2561C8.72883 6.57939 8.46829 6.84146 8.14691 6.84146H5.81922C5.49783 6.84146 5.2373 6.57939 5.2373 6.2561V5.67073Z",
    fill: "url(#paint15_linear_1542_2475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1542_2475",
    x1: 0.574905,
    y1: 16.5678,
    x2: 49.4638,
    y2: 16.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#A461FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamshopping);
export default __webpack_public_path__ + "static/media/streamshopping.544890446bd43215fd7e43800419f2fa.svg";
export { ForwardRef as ReactComponent };